// ko strings for messages/paywall.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const paywall: Dict = {
  // What each plan includes.
  "paywall.hl.unlimitedCovers": "무제한 커버",
  "paywall.hl.voices": "9만 3천 개 이상의 목소리",
  "paywall.hl.downloads": "다운로드",
  "paywall.hl.duetsTts": "듀엣과 텍스트 음성 변환",
  "paywall.hl.trainVoices": "나만의 목소리 학습",
  "paywall.hl.hdVideos": "1080p 영상",
  "paywall.hl.videoCoins": "매월 영상 코인 50개",
  "paywall.hl.marbleLyric": "Marble Run과 가사 영상",
  "paywall.hl.priority": "우선 처리",
  "paywall.hl.unlimitedCoins": "무제한 영상 코인",
  "paywall.hl.apiCredits": "매월 $25 상당의 API 크레딧",
  "paywall.hl.everythingCreator": "Creator의 모든 기능",
  "paywall.hl.thisCover": "지금 이 커버",

  // Why the paywall opened: headline and line under it.
  "paywall.reason.unlock.title": "커버 잠금 해제하기",
  "paywall.reason.unlock.body":
    "목소리와 오디오가 준비됐어요. 구독하면 커버 제작이 바로 시작되고 1분 정도면 완성돼요. 그다음엔 원하는 만큼 만들 수 있어요.",
  "paywall.reason.create.title": "커버를 만들 준비가 됐어요",
  "paywall.reason.create.body":
    "오디오와 목소리 설정이 끝났어요. 요금제를 선택해 만들고, 그다음엔 원하는 만큼 커버를 만들어 보세요.",
  "paywall.reason.browse.title": "원하는 목소리로 커버 만들기",
  "paywall.reason.browse.body":
    "무제한 커버, 다운로드, 9만 3천 개 이상의 모든 목소리. 언제든 해지할 수 있어요.",
  "paywall.reason.credits.title": "크레딧을 모두 사용했어요",
  "paywall.reason.credits.body":
    "다음 커버가 기다리고 있어요. Basic은 제한이 없어서 더 이상 크레딧을 셀 필요가 없어요.",
  "paywall.reason.words.title": "원하는 말을 목소리로 들려주세요",
  "paywall.reason.words.body":
    "가사를 입력하거나 노래를 설명하면 목소리가 노래하거나 말해 줘요. Basic부터 포함돼요.",
  "paywall.reason.video.title": "영상으로 만들기",
  "paywall.reason.video.body":
    "TikTok과 릴스에 바로 올릴 수 있는 Marble Run과 가사 영상. Creator에는 매월 영상 코인 50개가 포함돼요.",
  "paywall.reason.resume.title": "하던 곳에서 이어서 하기",
  "paywall.reason.resume.body":
    "선택한 요금제가 저장되어 있어요. 결제를 마치고 원하는 만큼 커버를 만들어 보세요.",
  "paywall.reason.train.title": "나만의 목소리 만들기",
  "paywall.reason.train.body":
    "몇 개의 샘플로 나만의 목소리를 학습시키고 어떤 커버에든 사용하세요. Creator에서는 무제한이에요.",

  // The main button.
  "paywall.cta.unlockFor": "{price}에 내 커버 잠금 해제",
  "paywall.cta.keepGoingFor": "{price}에 계속하기",
  "paywall.cta.backToCreatorFor": "{price}에 Creator로 돌아오기",
  "paywall.cta.backFor": "{price}에 다시 시작하기",
  "paywall.cta.startFor": "{price}로 시작하기",
  "paywall.cta.startPlanFor": "{price}에 {plan} 시작하기",

  // Renewal terms next to the pay button (required before payment).
  "paywall.renew.welcome":
    "구독하는 동안 계속 월 {price}. 해지할 때까지 매월 자동 갱신돼요.",
  "paywall.renew.then": "이후 월 {price}. 해지할 때까지 매월 자동 갱신돼요.",
  "paywall.renew.yearly":
    "오늘 12개월분 {price} 결제. 해지할 때까지 매년 자동 갱신돼요.",

  "paywall.toast.updated": "구독이 변경되었어요!",
  "paywall.toast.error": "문제가 발생했어요. 다시 시도해 주세요.",

  // Welcome back (their paid plan ended).
  "paywall.welcomeBack": "다시 오신 걸 환영해요",
  "paywall.priceMonth": "월 {price}",
  "paywall.welcome.offerCreator": "월 {price}에 Creator",
  "paywall.welcome.card":
    "직접 떠나신 게 아니라 결제가 완료되지 않아 요금제가 중단됐어요. {offer}(으)로 하던 곳에서 이어서 하세요.",
  "paywall.welcome.price":
    "가격이 부담된다고 하셔서 더 낮췄어요. {was} 대신 {offer}, 구독하는 동안 계속 이 가격이에요.",
  "paywall.welcome.broken":
    "잘 작동하지 않는 부분이 있다고 하셨죠. 지난 일주일 동안 커버 100개 중 {n}개가 문제없이 완성됐어요. {offer}(으)로 다시 시작해 보세요.",
  "paywall.welcome.secretCreator":
    "공개하지 않는 요금제로 Creator를 월 {price}에 이용하세요. 구독을 유지하는 동안 계속 이 가격이에요.",
  "paywall.welcome.secret":
    "이용하던 모든 기능을 공개하지 않는 요금제로 월 {price}에 이용하세요. 구독을 유지하는 동안 계속 이 가격이에요.",
  "paywall.welcome.coversHere": "커버 {n}개가 그대로 남아 있어요",
  "paywall.welcome.coverHere": "커버가 그대로 남아 있어요",
  "paywall.welcome.makeAgain": "다시 커버 만들기",
  "paywall.ended.today": "오늘 요금제가 종료됐어요",
  "paywall.ended.yesterday": "어제 요금제가 종료됐어요",
  "paywall.ended.days": "{n}일 전에 요금제가 종료됐어요",
  "paywall.ended.months": "{n}개월 전에 요금제가 종료됐어요",
  // Under "+12" on the extra covers tile.
  "paywall.more": "개 더",

  // Plan cards and the hero.
  "paywall.recommended": "추천",
  "paywall.perMonth": "/월",
  "paywall.perMonthStay": "/월, 구독하는 동안 계속",
  "paywall.firstMonth": "첫 달",
  "paywall.today": "오늘 결제",
  "paywall.heldFor": "{time} 동안 보관돼요",
  "paywall.coverReady": "커버를 만들 준비가 됐어요",
  "paywall.coverSetUp": "오디오와 목소리 설정이 끝났어요",
  "paywall.coversToday": "오늘 Jammable에서 만든 커버 {n}개",
  "paywall.coversTodayShort": "오늘 만든 커버 {n}개",
  "paywall.pickPlanUnlock": "요금제를 선택해 잠금 해제하세요",
  "paywall.pickPlan": "요금제 선택",
  "paywall.whatYouGet": "{plan} 혜택",
  "paywall.secure": "Stripe 안전 결제 · 언제든 해지 가능",
  "paywall.topPlan": "최상위 요금제를 이용 중이에요",
  "paywall.managePlan": "요금제 관리",

  // Checkout step.
  "paywall.changePlan": "요금제 변경",
  "paywall.planYearly": "{plan}, 연간",
  "paywall.planMonthly": "{plan} 요금제",
  "paywall.billedYearly": "연간 결제",
  "paywall.pay": "결제하기",
  "paywall.payUnlock": "결제하고 잠금 해제",
  "paywall.checkoutLoading": "결제 화면을 준비하고 있어요",

  // Leaving without the cover.
  "paywall.leave.title": "커버 없이 나가시겠어요?",
  "paywall.leave.oneStep": "한 단계만 남았어요.",
  "paywall.leave.audioIn": "오디오 추가 완료",
  "paywall.leave.voiceReady": "{names} 목소리가 부를 준비를 마쳤어요",
  "paywall.leave.voicesReady": "{names} 목소리가 부를 준비를 마쳤어요",
  "paywall.leave.voicePicked": "목소리 선택 완료",
  "paywall.leave.makeStep": "커버 만들기: 1분 정도",
  "paywall.leave.gets": "잠금 해제하면 받는 혜택",
  "paywall.leave.held":
    "{time} 동안 보관돼요. 그 후에는 사라져서 다시 만들어야 해요.",
  "paywall.unlockMyCover": "내 커버 잠금 해제",
  "paywall.leaveAnyway": "그래도 나가기",

  // The yearly gift on the leave step.
  "paywall.gift.wrapping": "선물을 포장하고 있어요…",
  "paywall.gift.beforeYouGo": "잠깐만요",
  "paywall.gift.saved": "선물을 준비해 뒀어요",
  "paywall.gift.openToSee": "열어서 확인해 보세요.",
  "paywall.gift.opening": "여는 중…",
  "paywall.gift.open": "선물 열기",
  "paywall.gift.noThanks": "괜찮아요, 나갈게요",
  "paywall.gift.yours": "나의 선물",
  "paywall.gift.headline": "월 {price}에 {plan}",
  "paywall.gift.body": "모든 목소리로 무제한 커버, 12개월 동안 이 가격 그대로.",
  "paywall.gift.save": "{pct}% 할인",
  "paywall.perMo": "/월",
  "paywall.gift.billedYearly": "연 {price} 결제",
  "paywall.gift.lockIn": "월 {price}로 확정하기",
  "paywall.seeMonthly": "월간 요금제 보기",

  // The locked cover's page.
  "paywall.locked.step.upload": "오디오 업로드 중",
  "paywall.locked.step.match": "목소리 맞추는 중",
  "paywall.locked.step.mix": "믹스 준비 중",
  "paywall.locked.yourAudio": "내 오디오",
  "paywall.locked.yourAiSong": "내 AI 노래",
  "paywall.locked.yourWords": "내 가사",
  "paywall.locked.yourVoice": "내 목소리",
  "paywall.locked.startFailed": "커버를 시작하지 못했어요. 다시 시도해 주세요.",
  "paywall.locked.makeNow": "지금 만들기",
  "paywall.unlock": "잠금 해제",
  "paywall.locked.pctDone": "{pct}% 완료",
  "paywall.locked.gettingReady": "{song}에 맞춰 {names} 준비 중",
  "paywall.locked.done": "완료",
  "paywall.locked.now": "진행 중",
  "paywall.locked.expired": "이 커버는 만료됐어요",
  "paywall.locked.expiredBody":
    "잠긴 커버는 48시간 동안 보관돼요. 1분이면 다시 만들 수 있어요.",
  "paywall.locked.makeAgain": "다시 만들기",
  "paywall.locked.readyToMake": "만들 준비 완료",
  "paywall.locked.readyOne": "{names} AI 목소리가 {song} 커버를 준비했어요",
  "paywall.locked.readyMany": "{names} AI 목소리가 {song} 커버를 준비했어요",
  "paywall.locked.onPlan":
    "요금제를 이용 중이라 바로 시작할 수 있어요. 1분 정도 걸려요.",
  "paywall.locked.unlockBody":
    "잠금 해제하면 커버 제작이 바로 시작돼요. 1분 정도 걸리고, 완성되면 다운로드하고 공유할 수 있어요.",
  "paywall.locked.change": "목소리나 오디오 변경",
  "paywall.locked.notMade": "아직 만들어지지 않은 커버예요",
  "paywall.locked.makeYourOwn": "{names} 목소리로 1분 만에 직접 만들어 보세요.",
  "paywall.locked.makeCover": "커버 만들기",

  // The locked video preview. "\n" is a line break.
  "paywall.video.unlock": "커버와 영상\n잠금 해제",
  "paywall.video.howItLooks": "영상은 이렇게 보일 거예요",
  "paywall.video.drawing": "영상을 그리는 중",
  "paywall.video.aria": "{cta}: 커버와 영상",

  // The return bar.
  "paywall.return.firstMonth": "첫 달 {price}",
  "paywall.return.waiting": "{title} 커버가 기다리고 있어요",
  "paywall.return.savedWaiting": "저장한 커버가 기다리고 있어요",
  "paywall.return.trialReady": "7일 무료 체험이 준비됐어요",
  "paywall.return.trialDetail":
    "오늘은 결제 없이, 이후 월 {price}. 언제든 해지할 수 있어요.",
  "paywall.return.startTrial": "무료 체험 시작하기",
  "paywall.return.funds": "카드 잔액이 부족하다고 카드사에서 알려 왔어요.",
  "paywall.return.declined": "카드사에서 결제를 거절했어요.",
  "paywall.return.cardFailed": "카드 결제가 완료되지 않았어요",
  "paywall.return.cardDetail":
    "카드 결제가 완료되지 않았어요. Apple Pay, Google Pay 또는 다른 카드로 시도해 보세요 · {price}",
  "paywall.return.whyDetail":
    "{why} Apple Pay, Google Pay 또는 다른 카드로 시도해 보세요 · {price}",
  "paywall.return.tryAnother": "다른 방법으로 결제",
  "paywall.return.confirm": "카드사에서 간단한 인증을 요청했어요",
  "paywall.return.confirmDetail": "한 단계만 더 하면 끝나요 · {price}",
  "paywall.return.finish": "결제 마치기",
  "paywall.return.planHere": "{plan} 요금제가 아직 저장되어 있어요",
  "paywall.return.heldMore": "{time} 더 보관돼요 · {price}",
  "paywall.return.thenRegular": "{price}, 이후 {regular}",
  "paywall.return.cancelAny": "{price}, 언제든 해지 가능",
  "paywall.return.pickUp": "하던 곳에서 이어서 하기",
  "paywall.return.cardStopped": "결제가 완료되지 않아 요금제가 중단됐어요",
  "paywall.return.comeBack": "Jammable로 돌아오세요",
  "paywall.return.pickUpFor": "{offer}(으)로 하던 곳에서 이어서 하세요.",
  "paywall.return.secretOffer":
    "공개하지 않는 요금제로 {offer}에 다시 시작하세요.",
  "paywall.return.hide": "숨기기",
};

export default paywall;
